import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function fetchPazzport(pazzport, park_id){
    const pazzportResponse = await axios.get(`integration/kidzoft/park/${park_id}/pazzport/${pazzport}`, { withCredentials : true });
    return pazzportResponse?.data;
}

async function updateVisitDate(params){
    const updateVisitDateResponse = await axios.post(`integration/kidzoft/updateDate`, params, { withCredentials : true, });
    return updateVisitDateResponse?.data;
}

export default {
    fetchPazzport,
    updateVisitDate,
}